import PropTypes from 'prop-types';
import {useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Transition, Message} from 'semantic-ui-react';

import {removeSuccessMessage} from 'state/actions';
import {getSuccessMessages} from 'state/selectors';

import styles from './SuccessMessages.module.scss';

function SuccessMessage({message, mountNode}) {
  const [isVisible, setIsVisible] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch]);

  return (
    <Transition
      key={message.id}
      mountNode={mountNode}
      animation="fly down"
      duration={{show: 500, hide: 1000}}
      onHide={() => dispatch(removeSuccessMessage(message.id))}
      transitionOnMount
      visible={isVisible}
    >
      <Message key={message.id} icon="checkmark" content={message.message} positive />
    </Transition>
  );
}

SuccessMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  mountNode: PropTypes.object.isRequired,
};

export default function SuccessMessages() {
  const messages = useSelector(getSuccessMessages);
  const container = useRef(null);

  return (
    <div ref={container} className={styles.SuccessMessages}>
      {messages.map(message => (
        <SuccessMessage key={message.id} mountNode={container.current} message={message} />
      ))}
    </div>
  );
}
